// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".btn-facebook[data-v-2334abfa]{background:#3a63be;border-color:#3a63be;color:#fff!important;font-weight:700;position:relative}.btn-facebook svg[data-v-2334abfa]{height:1rem;left:1.25rem;position:absolute}.btn-facebook[data-v-2334abfa]:hover{background:#2e4f97;border-color:#2e4f97}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
